@if (review) {
  @if (review.attributes.star_rating >= 3) {
    <h5 class="heading__regular--xxs mb-3">{{ review.attributes.title }}</h5>
  }
  @for (answer of reviewAnswers; track answer) {
    <div class="mt-4">
      <h6 class="heading__regular--xxxxs">{{ answer.text }}</h6>
      <p>{{ answer.value }}</p>
    </div>
  }
  <a
    (click)="reviewModalService.openReadReviewDialog(review.attributes.url)"
    class="my-3 underline--hover--black text-black udex-cursor-pointer focusable focusable__element offset-none"
    href="javascript:void(0)">
    {{ 'productReview.readThisReviewOnG2' | cxTranslate }}
  </a>
}
